/** Formes canoniques stockées dans le champ date (conventions catalogue). */
export const UNKNOWN_DATE_CANONICAL = "s. d.";
export const UNCERTAIN_DATE_SUFFIX = " ca.";

const UNKNOWN_DATE_ALIASES = [
  "s. d.",
  "s.d.",
  "sd",
  "n. d.",
  "n.d.",
  "nd",
  "s. f.",
  "s.f.",
  "z. d.",
  "z.d.",
];

export function isUnknownDateValue(value: string | undefined | null): boolean {
  if (value == null) return false;
  const normalized = value.trim().toLocaleLowerCase("fr").replace(/\s+/g, " ");
  return UNKNOWN_DATE_ALIASES.some(
    (alias) => alias.toLocaleLowerCase("fr") === normalized,
  );
}

export function hasUncertainDateSuffix(value: string | undefined | null): boolean {
  if (value == null) return false;
  return /\s+ca\.?\s*$/i.test(value.trim());
}

export function stripUncertainDateSuffix(value: string): string {
  return value.replace(/\s+ca\.?\s*$/i, "").trimEnd();
}

export function appendUncertainDateSuffix(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return UNCERTAIN_DATE_SUFFIX.trimStart();
  if (hasUncertainDateSuffix(trimmed)) return trimmed;
  return `${trimmed}${UNCERTAIN_DATE_SUFFIX}`;
}

export type DateQualifierFlags = {
  unknownDate?: boolean;
  uncertainDate?: boolean;
  estimatedDate?: boolean;
};

/**
 * Formate une date pour affichage (header, listes non-CF).
 * Les booléens priment ; sinon on s'appuie sur le contenu du champ.
 */
export function formatDateWithQualifiers(
  date: string | undefined | null,
  flags: DateQualifierFlags = {},
  labels: { unknown: string; circa: string } = {
    unknown: UNKNOWN_DATE_CANONICAL,
    circa: UNCERTAIN_DATE_SUFFIX,
  },
): string {
  if (flags.unknownDate) return labels.unknown;

  const raw = (date ?? "").trim();
  if (!raw) return "";

  if (isUnknownDateValue(raw)) return labels.unknown;

  const base = stripUncertainDateSuffix(raw);
  if (flags.uncertainDate || hasUncertainDateSuffix(raw)) {
    return `${base}${labels.circa}`;
  }
  return base;
}

/**
 * Formate pour un titre de fiche : `Titre - date` ou titre seul.
 */
export function appendFormattedDateToTitle(
  title: string,
  date: string | undefined | null,
  flags?: DateQualifierFlags,
  labels?: { unknown: string; circa: string },
): string {
  const formatted = formatDateWithQualifiers(date, flags, labels);
  if (!formatted) return title;
  return `${title} - ${formatted}`;
}
